<!--
@Author: Tom Voorneveld <tom>
@Date:   2019-05-16T16:35:54+02:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2019-05-17T11:11:17+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Props override SocialShare modal's default
-->

<template>
  <span @click="smData()">
    <icon
      v-b-modal.sm-modal
      style="cursor:pointer;"
      name="share-alt"
      :scale="scale * 1.85"
      class="social-share-button"/>
  </span>
</template>

<script>

export default {
  name: 'SocialShareButton',
  props: {
    // button appearance
    scale: { type: Number, default: 1 }, // *  1.75 because of padding
    // passing to social sharer:
    title: { type: String },
    twitterUser: { type: String },
    url: { type: String },
    description: { type: String },
    quote: { type: String },
    hashtags: { type: String }
  },
  methods: {
    smData () {
      this.$root.$emit('sm_share', {
        title: this.title,
        twitter_user: this.twitterUser,
        url: this.url,
        description: this.description,
        quote: this.quote,
        hashtags: this.hashtags
      })
    }
  }
}
</script>

<style lang="scss">

.social-share-button {
  padding: 6px;
  margin-top: -4px;
}
</style>
